import { render, staticRenderFns } from "./api_test.vue?vue&type=template&id=8cbe91c4&"
import script from "./api_test.vue?vue&type=script&lang=js&"
export * from "./api_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports